import { render, staticRenderFns } from "./top10.vue?vue&type=template&id=001b3948&scoped=true&"
import script from "./top10.vue?vue&type=script&lang=ts&"
export * from "./top10.vue?vue&type=script&lang=ts&"
import style0 from "./top10.vue?vue&type=style&index=0&id=001b3948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b3948",
  null
  
)

export default component.exports